import { rem } from 'polished'
import * as React from 'react'
import styled from 'styled-components'
import TextButton from 'LuxKit/Button/TextButton'
import LineTrashAltIcon from 'LuxKit/Icons/line/LineTrashAltIcon'
import zIndex from 'styles/tools/z-index'
import LinePlusIcon from 'LuxKit/Icons/line/LinePlusIcon'
import { tileDesktopLayout } from './constants'
import { useIntl } from 'react-intl'

const StyledButtonsContainer = styled.div`
  z-index: ${zIndex.reviewCartButtons};
  display: flex;
  justify-content: start;
  column-gap: ${rem(8)};

  ${tileDesktopLayout} {
    justify-content: end;
  }
`

interface Props {
  isBookable?: boolean
  saveForLater?: boolean
  onSaveForLater?: React.MouseEventHandler<HTMLButtonElement>
  onDelete?: React.MouseEventHandler<HTMLButtonElement>
}

function CartReviewTileActions({
  isBookable,
  saveForLater,
  onSaveForLater,
  onDelete,
}: Props) {
  const intl = useIntl()
  const saveForLaterLabel = intl.formatMessage({
    id: 'laKLQKQ68pmd27uW6v4R',
    defaultMessage: 'Save for later',
    description: 'Button text to save cart item for later in the shopping cart interface',
  })
  const addLabel = intl.formatMessage({
    id: '3pTncErYaDMSpmM4XxiN',
    defaultMessage: 'Add',
    description: 'Button text to add saved item back to cart in the cart view',
  })
  const deleteLabel = intl.formatMessage({
    id: 'JvRaptmTpdkakbfBSvjc',
    defaultMessage: 'Delete',
    description: 'Button text to delete item from cart in the shopping cart interface',
  })

  return <StyledButtonsContainer>
    {isBookable && <>
      {!saveForLater && <TextButton
        kind="secondary"
        size="small"
        shape="round"
        onClick={onSaveForLater}
      >
        {saveForLaterLabel}
      </TextButton>}
      {saveForLater && <TextButton
        kind="primary"
        size="small"
        shape="round"
        startIcon={<LinePlusIcon />}
        onClick={onSaveForLater}
      >
        {addLabel}
      </TextButton>}
    </>}
    <TextButton
      kind="secondary"
      size="small"
      shape="round"
      startIcon={<LineTrashAltIcon />}
      onClick={onDelete}
    >
      {deleteLabel}
    </TextButton>
  </StyledButtonsContainer>
}

export default CartReviewTileActions
